/**
 * @generated SignedSource<<f042811427e3ad17f2f2aede24d9301b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionOverviewPageDescriptionsFragment$data = {
  readonly about: string | null | undefined;
  readonly audienceGroups: {
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"AudienceGroupsFragment">;
  };
  readonly gettingStarted: string | null | undefined;
  readonly host: {
    readonly " $fragmentSpreads": FragmentRefs<"HostCardFragment">;
  };
  readonly purpose: string | null | undefined;
  readonly rewardCount: {
    readonly totalCount: number;
  };
  readonly timeline: {
    readonly " $fragmentSpreads": FragmentRefs<"TimelineFragment">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"RewardsFragment" | "TagListFragment">;
  readonly " $fragmentType": "CompetitionOverviewPageDescriptionsFragment";
};
export type CompetitionOverviewPageDescriptionsFragment$key = {
  readonly " $data"?: CompetitionOverviewPageDescriptionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionOverviewPageDescriptionsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionOverviewPageDescriptionsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "about",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "purpose",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gettingStarted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Timeline",
      "kind": "LinkedField",
      "name": "timeline",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TimelineFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AudienceGroupConnection",
      "kind": "LinkedField",
      "name": "audienceGroups",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AudienceGroupsFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "rewardCount",
      "args": null,
      "concreteType": "RewardConnection",
      "kind": "LinkedField",
      "name": "rewards",
      "plural": false,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "host",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HostCardFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RewardsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TagListFragment"
    }
  ],
  "type": "Competition",
  "abstractKey": null
};
})();

(node as any).hash = "b2754e58833e2b5f9181491ec7e80480";

export default node;
